/*
	@param {string} string representing the price value in dollars
	@return {int} integer value representing the price in cents
*/
export const formatPriceCents = (string) => parseFloat(string) * 100

export const formatPriceDollars = (price, symbol = '$') => `${symbol}${(Math.round(price) / 100).toFixed(2)}`

export const getUrlParams = (param_string) => {
	let hashes = param_string.slice(param_string.indexOf('?') + 1).split('&');
	return hashes.reduce((params, hash) => {
		let [key, val] = hash.split('=')
		return Object.assign(params, { [key]: decodeURIComponent(val) })
	}, {})
}

export const productVariantFromBase64String = (string) => {
	const splitString = atob(string).split('/');
	return splitString[splitString.length - 1];
}

